// extracted by mini-css-extract-plugin
module.exports = {"itemTableHeader":"Cart_itemTableHeader__hRC39","itemTableHairline":"Cart_itemTableHairline____iZ5","itemTableImage":"Cart_itemTableImage__6_Ted"};